import { Injectable } from '@angular/core';
import { environment } from '../../src/environments/environment';

/**
 * Service to check if capture mode is enabled
 * Capture mode is enabled via environment.captureMode flag
 */
@Injectable({
  providedIn: 'root'
})
export class CaptureModeService {
  private _isEnabled: boolean;

  constructor() {
    this._isEnabled = environment.captureMode === true;

    if (this._isEnabled) {
      console.log('🎥 Capture mode ENABLED');
    }
  }

  get isEnabled(): boolean {
    return this._isEnabled;
  }
}
